module.exports = __webpack_public_path__ + "wordScaleSnapInTop.gif";